import { HttpClient } from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnChanges,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { environment } from "@environments/environment";
import { faTrash } from "@fortawesome/pro-solid-svg-icons";

import { faGripDotsVertical } from "@fortawesome/pro-light-svg-icons";
const USER_DATA: any[] = [];

const COLUMNS_SCHEMA = [
  {
    key: "condition",
    key2: "",
    type: "condition",
    label: "Threshold",
    required: false,
    width: 150,
  },
  {
    key: "value",
    key2: "valueEnd",
    type: "value",
    label: "",
    required: false,
    width: 0,
  },
  {
    key: "valueEnd",
    key2: "valueEnd",
    type: "valueEnd",
    label: "Enter Threshold Value",
    required: true,
    width: 400,
  },
  {
    key: "color",
    key2: "",
    type: "color",
    label: "Choose Color",
    required: true,
    width: 100,
  },
  {
    key: "isEdit",
    key2: "",
    type: "isEdit",
    label: "",
    required: false,
    width: 50,
  },
];
const COLUMNS_SCHEMA_FOOTER = [
  {
    key: "condition",
    key2: "",
    type: "condition",
    label: "Threshold",
    required: false,
    width: 150,
  },
  {
    key: "value",
    key2: "valueEnd",
    type: "value",
    label: "",
    required: false,
    width: 0,
  },
  {
    key: "valueEnd",
    key2: "valueEnd",
    type: "valueEnd",
    label: "Enter Threshold Value",
    required: true,
    width: 400,
  },
  {
    key: "color",
    key2: "",
    type: "color",
    label: "Choose Color",
    required: true,
    width: 100,
  },
  {
    key: "isEdit",
    key2: "",
    type: "isEdit",
    label: "",
    required: false,
    width: 50,
  },
];

@Component({
    selector: "app-configure-thresholds",
    templateUrl: "./configure-thresholds.component.html",
    styleUrls: ["./configure-thresholds.component.scss"],
    standalone: false
})
export class ConfigureThresholdsComponent implements OnInit, OnChanges {
  public editForm!: UntypedFormGroup;
  field: any;
  auto: any;
  fieldData: any;
  fieldColorData: any;
  fieldsHidden: boolean = false;
  message: string = "Are you sure?";
  private dataPointId!: number;
  name: string = "";
  type: string = "";
  typeEnding: string = "";
  typeBeginning: string = "";
  expressionName: string = "";
  public formFields: any[] = [];
  public displayRules: any;
  public filteredDisplayRules: any[] = [];
  public fieldConfig: any;
  public loading: boolean = true;
  dragDisabled = true;
  faGripDotsVertical = faGripDotsVertical;
  dataSource = USER_DATA;
  columnsSchema: any = COLUMNS_SCHEMA;
  displayedColumns: string[] = COLUMNS_SCHEMA.map((col) => col.key);
  displayedColumnsFooter: string[] = COLUMNS_SCHEMA_FOOTER.map(
    (col) => col.key
  );
  noLimitColor: any;

  faTrash = faTrash;
  emptyVal: any;
  chartType: any;
  public error: boolean = false;

  @ViewChild("target") private myScrollContainer!: ElementRef;

  constructor(
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private cdRef: ChangeDetectorRef,
    private dialogRef: MatDialogRef<ConfigureThresholdsComponent>
  ) {
    if (data) {
      this.message = data.message || this.message;
      this.dataPointId = data.id;
      this.fieldData = data.field;
      if (data.field && data.field.dynamicChartColors)
        this.fieldColorData = data.field.dynamicChartColors;
      this.auto = data.auto;
      this.chartType = data.chartType;
      if (this.fieldData && this.fieldData.name)
        this.name = this.fieldData.name;
    }
  }

  rowFormContents(row: any) {
    this.dataSource[row.id].form = row.form;
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop =
        this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) {}
  }
  addRow(rowdata?: any) {
    let newRow = {};
    if (rowdata) {
      newRow = {
        id: Math.floor(Math.random() * Math.floor(Math.random() * Date.now())),
        color: rowdata.color,
        value: rowdata.value,
        valueEnd: rowdata.valueEnd,
        isEdit: true,
      };
    } else {
      let beginningThreshold = 0;
      if (this.dataSource.length > 0)
        beginningThreshold =
          this.dataSource[this.dataSource.length - 1].valueEnd + 1;
      newRow = {
        id: Math.floor(Math.random() * Math.floor(Math.random() * Date.now())),
        value: beginningThreshold,
        color: "",
        isEdit: true,
      };
    }
    // this.dataSource = [newRow, ...this.dataSource];
    this.dataSource = [...this.dataSource, newRow];
    // this.dataSource.push(newRow);
    setTimeout(() => {
      this.scrollToBottom();
      this.validateForm();
    }, 100);
  }

  removeRow(id: any) {
    this.dataSource = this.dataSource.filter((u) => u.id !== id);
  }

  onChange(event: any, element: any) {}

  validateForm() {
    let disabled = true;
    let validRow = true;
    this.dataSource.forEach((row: any, i: any) => {
      validRow =
        validRow && this.validateRow(row, this.dataSource.length == i + 1);
    });
    disabled = disabled && !validRow;
    if (!this.noLimitColor) disabled = true;
    return disabled;
  }
  validateFormWithoutLimit() {
    let disabled = true;
    let validRow = true;
    this.dataSource.forEach((row: any, i: any) => {
      validRow =
        validRow && this.validateRow(row, this.dataSource.length == i + 1);
    });
    disabled = disabled && !validRow;
    return disabled;
  }

  getPlaceholder(row: any) {
    let placeholder = "Enter Value";
    // if (this.dataSource.length == row) placeholder = "Leave blank for no limit";
    return placeholder;
  }
  validateStructure() {
    const data: any = {};
    data.items = [];

    this.dataSource.forEach((row: any) => {
      const datarow: any = {};
      datarow.dataPointId = this.dataPointId;
      datarow.color = row.color;
      //dynamically choosing colors for text based on the background color chosen
      datarow.textColor = this.pickTextColorBasedOnBgColorSimple(
        row.color,
        "#FFFFFF",
        "#000000"
      );

      data.items.push(datarow);
    });

    this.error = false;
    var valueArr = data.items.map(function (item: any) {
      const temp = JSON.stringify(item.value);
      return temp;
    });

    var isDuplicate = valueArr.some(function (item: any, idx: any) {
      return valueArr.indexOf(item) != idx;
    });
  }
  validateRow(row: any, lastRow: boolean) {
    let validRow = true;

    if (row.color == "") {
      validRow = false;
    } else {
      if (row.valueEnd == null) {
        validRow = false;
      }
    }
    return validRow;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onConfirmClick(): void {
    const data: any = {};
    data.items = [];

    this.dataSource.forEach((row: any) => {
      let value = row.valueEnd;
      if (value == 0) value = -1;
      const datarow: any = {};
      datarow.dataPointId = this.dataPointId;
      datarow.value = value;
      datarow.valueEnd = row.valueEnd;
      datarow.color = row.color;
      data.items.push(datarow);
    });
    data.items.sort(function (a: any, b: any) {
      return a.valueEnd - b.valueEnd;
    });
    const nolimit: any = {};
    nolimit.dataPointId = this.dataPointId;
    nolimit.value = 0;
    nolimit.valueEnd = null;
    nolimit.color = this.noLimitColor;
    data.items.push(nolimit);

    if (this.editForm.valid) {
      this.dialogRef.close(data);
    }
  }

  pickTextColorBasedOnBgColorSimple(
    bgColor: string,
    lightColor: string,
    darkColor: string
  ) {
    var color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
  }

  onCancelClick(): void {
    this.dialogRef.close(null);
  }

  ngOnChanges() {
    this.cdRef.markForCheck();
    this.cdRef.detectChanges();
  }

  getConfiguration() {
    this.loading = false;
    if (this.fieldColorData) {
      this.fieldColorData.forEach((row: any) => {
        if (row.valueEnd != null) this.addRow(row);
        if (row.valueEnd == null) this.noLimitColor = row.color;
      });
    } else {
      this.addRow();
    }
  }
  ngOnInit(): void {
    this.editForm = this.fb.group({});
    this.getConfiguration();
  }
}
